import { differenceInDays, format } from 'date-fns';

export class CloudSightDate {

  static getDaysDifference(startTimestamp1: number, endTimestamp: number): number {
    const date1 = new Date(startTimestamp1);
    const date2 = new Date(endTimestamp);
    return differenceInDays(date2, date1);
  }

  day?: number;
  month?: number;
  year?: number;
  date?: string;
  unixTimestamp?: number;
  description?: string;

  constructor(unixTimestamp: number) {
    this.unixTimestamp = unixTimestamp;
    const dateValues = new Date(unixTimestamp).toISOString().split('-');
    this.year = parseInt(dateValues[0], 10);
    this.month = parseInt(dateValues[1], 10);
    this.day = parseInt(dateValues[2], 10);

    this.description = this._createDescription(this.day, this.month, this.year);
  }

  private _createDescription(day: number, month: number, year: number) {
    return format(new Date(year, month - 1, day), 'Do MMM, YYYY');
  }
}
